import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  IconButton,
} from "@mui/material"
import { Close } from "@mui/icons-material"

const BlockedDeleteModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-testid="blocked-delete-modal"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {i18n.t("costs.delete.blocked.title")}
        </Box>
        <IconButton onClick={onClose} size="small" data-testid="close-button">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {i18n.t("costs.delete.blocked.message")}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="branded">
          {i18n.t("buttons.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

BlockedDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default BlockedDeleteModal
